/* eslint-disable @typescript-eslint/unbound-method */
import { Injectable } from '@angular/core'
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { CustomValidators } from '@se-po/shared-data-access-validators'

@Injectable({
  providedIn: 'root'
})
export class PasswordFormCreateService {

  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) { }

  public createForm(prefillMarketingCheckboxes: boolean): UntypedFormGroup {
    this.form = this.fb.group({
      password: ['', [Validators.required, CustomValidators.password]],
      specialOffers: [prefillMarketingCheckboxes],
      thirdPartyMailing: [prefillMarketingCheckboxes]
    })
    return this.form
  }
}
